import { render } from "./UploadSucceeded.vue?vue&type=template&id=7cf2e46c&ts=true"
import script from "./UploadSucceeded.vue?vue&type=script&lang=ts"
export * from "./UploadSucceeded.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__